// On window, not module state: a modal can mount from a chunk with its own copy of these modules
// (liswp_blocks/AGENTS.md), and window is the one channel every copy shares.
export const PUBLISHED_PAGE_LANG_KEY = '__aeduPageLang';

type PublishedWindow = Window & { [PUBLISHED_PAGE_LANG_KEY]?: string };

export function publishedPageLang(): string | undefined {
  return typeof window === 'undefined'
    ? undefined
    : (window as PublishedWindow)[PUBLISHED_PAGE_LANG_KEY];
}

export function publishPageLang(lang: string): void {
  if (typeof window !== 'undefined') {
    (window as PublishedWindow)[PUBLISHED_PAGE_LANG_KEY] = lang;
  }
}
